import { EditableFieldProps } from '../core-field/editable-field-json-props'

export const UI2_SWITCH_FIELD_DEFAULT_PROPS: Partial<UI2SwitchFieldProps> = {
  /**
   * @platform desktopWeb — DW only.
   *
   * MW and NM always render the two-column layout (switch and label in one
   * row) and ignore this entirely: NM has no horizontal branch at all, and
   * the DW component forces two-column when `UI2PlatformContext` reports
   * `mobileWeb`. Note that the MW force-set in `withUI2MobileWeb` is not
   * enough on its own — `withUI2FormContext` re-applies this default over
   * it. See the layout section in `.claude/rules/webapp.md`.
   */
  isHorizontalLayout: true,
}

export interface UI2SwitchFieldProps extends EditableFieldProps<boolean> {}
